module.exports = __webpack_public_path__ + "static/media/cross-pattern-white.0a434548.svg";